module.exports = __webpack_public_path__ + "img/mp-rank-item__img-2.99805522.jpg";